import config from '@/config'
import { getToken, logout } from '@/utils/auth'
import router from '@/router'

let redirectingToLogin = false

function showMessage(msg) {
  if (!msg) return
  if (typeof window !== 'undefined' && window.__yqzxToast) {
    window.__yqzxToast(msg)
    return
  }
  console.warn('[API]', msg)
}

function redirectToLogin() {
  if (redirectingToLogin) return
  redirectingToLogin = true
  logout()
  const current = router.currentRoute
  if (current && current.path !== '/login') {
    router.replace({
      path: '/login',
      query: { redirect: current.fullPath }
    })
  }
  setTimeout(() => {
    redirectingToLogin = false
  }, 1000)
}

function buildUrl(path) {
  const base = config.HTTP_REQUEST_URL.replace(/\/$/, '')
  const p = path.startsWith('/') ? path.slice(1) : path
  return `${base}/${p}`
}

async function request(method, path, data, options = {}) {
  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {})
  }

  const token = getToken()
  if (token) {
    headers[config.TOKEN_NAME] = token
  }

  const fetchOptions = {
    method,
    headers
  }

  if (data !== undefined && method !== 'GET') {
    fetchOptions.body = JSON.stringify(data)
  }

  let response
  try {
    response = await fetch(buildUrl(path), fetchOptions)
  } catch (err) {
    showMessage('网络请求失败，请稍后重试')
    return Promise.reject(err)
  }

  let body
  try {
    body = await response.json()
  } catch {
    showMessage('服务器响应异常')
    return Promise.reject(new Error('Invalid JSON response'))
  }

  if (body.code === 1) {
    return body.data === undefined ? {} : body.data
  }

  if (body.code === 302) {
    redirectToLogin()
    return new Promise(() => {})
  }

  const message = body.msg || '请求失败'
  showMessage(message)
  return Promise.reject(new Error(message))
}

export const http = {
  get(path, params) {
    let url = path
    if (params && Object.keys(params).length) {
      const qs = new URLSearchParams(params).toString()
      url = `${path}${path.includes('?') ? '&' : '?'}${qs}`
    }
    return request('GET', url)
  },
  post(path, data) {
    return request('POST', path, data)
  }
}

export default http
